// 10 Curated Recipes for ShareRecipe Public Access
import PicRecipe1 from "../assets/comida_1.svg";
import PicRecipe2 from "../assets/comida_2.svg";
import PicRecipe3 from "../assets/comida_3.svg";
import PicRecipe4 from "../assets/comida_4.svg";

export const RECIPES_DATA = [
  {
    id: "broccoli-salad-with-bacon",
    title: "Broccoli Salad With Bacon",
    prepTime: "15 mins",
    servings: 4,
    diet: "Keto / Low-Carb",
    cuisine: "American",
    mealType: "Salad / Side",
    rating: 4.9,
    image: PicRecipe1,
    description: "Crispy bacon, fresh broccoli florets, sharp cheddar cheese, and toasted sunflower seeds tossed in a creamy tangy dressing.",
    ingredients: [
      { ingredient: "Fresh Broccoli Florets", count: "4", unit: "cups" },
      { ingredient: "Crispy Cooked Bacon (crumbled)", count: "8", unit: "slices" },
      { ingredient: "Shredded Sharp Cheddar", count: "1", unit: "cup" },
      { ingredient: "Red Onion (diced)", count: "1/2", unit: "cup" },
      { ingredient: "Sunflower Seeds", count: "1/3", unit: "cup" },
      { ingredient: "Mayonnaise", count: "1/2", unit: "cup" },
      { ingredient: "Apple Cider Vinegar", count: "2", unit: "tbsp" }
    ],
    directions: [
      "In a large mixing bowl, combine fresh broccoli florets, crumbled bacon, diced red onion, cheddar cheese, and sunflower seeds.",
      "In a small bowl, whisk together mayonnaise, apple cider vinegar, salt, and black pepper until smooth.",
      "Pour the dressing over the broccoli mixture and toss thoroughly to coat.",
      "Chill in the refrigerator for at least 30 minutes before serving."
    ],
    nutrition: { calories: "320 kcal", protein: "12g", carbs: "8g", fat: "26g" },
    club: "Keto & Fitness Meal Prep"
  },
  {
    id: "classic-beef-burgers",
    title: "Classic Beef Burgers",
    prepTime: "25 mins",
    servings: 4,
    diet: "High Protein",
    cuisine: "American",
    mealType: "Main Course",
    rating: 4.8,
    image: PicRecipe2,
    description: "Juicy handcrafted beef patties seasoned to perfection, melted cheddar cheese, fresh lettuce, tomato, and signature burger sauce on toasted brioche buns.",
    ingredients: [
      { ingredient: "Ground Beef (80/20)", count: "500", unit: "g" },
      { ingredient: "Brioche Buns", count: "4", unit: "pieces" },
      { ingredient: "Cheddar Cheese Slices", count: "4", unit: "slices" },
      { ingredient: "Fresh Crisp Lettuce", count: "4", unit: "leaves" },
      { ingredient: "Ripe Tomato Slices", count: "1", unit: "large" },
      { ingredient: "Garlic Powder & Black Pepper", count: "1", unit: "tsp" }
    ],
    directions: [
      "Divide ground beef into 4 equal portions and form into patties about 3/4 inch thick.",
      "Season both sides generously with salt, pepper, and garlic powder.",
      "Preheat a cast-iron skillet over high heat with a touch of oil.",
      "Sear patties for 3-4 minutes per side. Add cheddar cheese slice on top during the last minute.",
      "Assemble on toasted brioche buns with lettuce, tomato, pickles, and sauce."
    ],
    nutrition: { calories: "550 kcal", protein: "34g", carbs: "28g", fat: "32g" },
    club: "Quick 15-Minute Meals"
  },
  {
    id: "classic-potato-salad",
    title: "Classic Potato Salad",
    prepTime: "20 mins",
    servings: 6,
    diet: "Vegetarian",
    cuisine: "European",
    mealType: "Side Dish",
    rating: 4.9,
    image: PicRecipe3,
    description: "Tender Yukon gold potatoes tossed with hard-boiled eggs, crunchy celery, fresh dill, and a creamy mustard-mayo dressing.",
    ingredients: [
      { ingredient: "Yukon Gold Potatoes", count: "1", unit: "kg" },
      { ingredient: "Hard-Boiled Eggs (chopped)", count: "4", unit: "large" },
      { ingredient: "Celery (diced)", count: "2", unit: "stalks" },
      { ingredient: "Dijon Mustard", count: "2", unit: "tbsp" },
      { ingredient: "Mayonnaise", count: "3/4", unit: "cup" },
      { ingredient: "Fresh Chopped Dill", count: "2", unit: "tbsp" }
    ],
    directions: [
      "Boil potatoes in salted water until fork-tender (approx. 15 minutes). Drain and cool completely, then cube.",
      "In a large bowl, mix mayonnaise, Dijon mustard, fresh dill, salt, and pepper.",
      "Fold in cubed potatoes, chopped eggs, celery, and red onion.",
      "Refrigerate for 1 hour to allow flavors to meld."
    ],
    nutrition: { calories: "280 kcal", protein: "7g", carbs: "32g", fat: "14g" },
    club: "Mediterranean Delights"
  },
  {
    id: "cherry-cobbler-on-the-grill",
    title: "Cherry Cobbler on the Grill",
    prepTime: "35 mins",
    servings: 8,
    diet: "Dessert",
    cuisine: "BBQ / American",
    mealType: "Dessert",
    rating: 4.9,
    image: PicRecipe4,
    description: "Sweet tart cherry filling topped with golden buttery biscuit crust baked right on the outdoor grill in a cast-iron skillet.",
    ingredients: [
      { ingredient: "Fresh or Frozen Cherries", count: "5", unit: "cups" },
      { ingredient: "Granulated Sugar", count: "3/4", unit: "cup" },
      { ingredient: "Lemon Juice", count: "1", unit: "tbsp" },
      { ingredient: "All-Purpose Flour", count: "1.5", unit: "cups" },
      { ingredient: "Cold Butter (cubed)", count: "1/2", unit: "cup" },
      { ingredient: "Vanilla Bean Extract", count: "1", unit: "tsp" }
    ],
    directions: [
      "Preheat grill for indirect cooking at 375°F (190°C).",
      "Toss cherries with sugar, cornstarch, lemon juice, and vanilla in a cast-iron skillet.",
      "Prepare biscuit topping by cutting cold butter into flour, baking powder, and sugar.",
      "Spoon biscuit dough over cherry filling and place skillet on indirect heat on grill.",
      "Cover and bake for 35-40 minutes until fruit is bubbly and topping is golden brown."
    ],
    nutrition: { calories: "340 kcal", protein: "4g", carbs: "52g", fat: "13g" },
    club: "Artisanal Baking & Desserts"
  },
  {
    id: "avocado-toast-supreme",
    title: "Avocado Toast Supreme",
    prepTime: "10 mins",
    servings: 2,
    diet: "Vegan / Healthy",
    cuisine: "Modern",
    mealType: "Breakfast",
    rating: 4.7,
    image: PicRecipe1,
    description: "Artisanal sourdough toast layered with creamy smashed avocado, heirloom tomatoes, microgreens, and everything bagel seasoning.",
    ingredients: [
      { ingredient: "Sourdough Bread Slices", count: "2", unit: "slices" },
      { ingredient: "Ripe Hass Avocados", count: "2", unit: "medium" },
      { ingredient: "Lemon Juice", count: "1", unit: "tbsp" },
      { ingredient: "Heirloom Cherry Tomatoes", count: "1/2", unit: "cup" },
      { ingredient: "Everything Bagel Seasoning", count: "1", unit: "tsp" }
    ],
    directions: [
      "Toast sourdough slices until golden and crisp.",
      "Mash ripe avocados with lemon juice, sea salt, and red pepper flakes.",
      "Spread avocado generously over toast and top with sliced tomatoes and microgreens.",
      "Sprinkle everything bagel seasoning and olive oil drizzle."
    ],
    nutrition: { calories: "290 kcal", protein: "8g", carbs: "26g", fat: "18g" },
    club: "Healthy Vegans & Plant-Based"
  },
  {
    id: "creamy-tuscan-garlic-chicken",
    title: "Creamy Tuscan Garlic Chicken",
    prepTime: "25 mins",
    servings: 4,
    diet: "Gluten-Free / Keto",
    cuisine: "Italian",
    mealType: "Main Course",
    rating: 4.9,
    image: PicRecipe2,
    description: "Tender pan-seared chicken breasts smothered in a rich garlic parmesan cream sauce with sun-dried tomatoes and wilted spinach.",
    ingredients: [
      { ingredient: "Boneless Chicken Breasts", count: "4", unit: "pieces" },
      { ingredient: "Garlic (minced)", count: "5", unit: "cloves" },
      { ingredient: "Sun-Dried Tomatoes", count: "1/2", unit: "cup" },
      { ingredient: "Fresh Baby Spinach", count: "2", unit: "cups" },
      { ingredient: "Heavy Cream", count: "1", unit: "cup" },
      { ingredient: "Grated Parmesan Cheese", count: "1/2", unit: "cup" }
    ],
    directions: [
      "Season chicken breasts with Italian herbs, salt, and pepper.",
      "Sear chicken in olive oil for 6 minutes per side until golden; set aside.",
      "In the same skillet, saute garlic, sun-dried tomatoes, heavy cream, and parmesan cheese until bubbling.",
      "Stir in baby spinach until wilted, return chicken to skillet and simmer for 3 minutes."
    ],
    nutrition: { calories: "460 kcal", protein: "42g", carbs: "7g", fat: "30g" },
    club: "Gourmet Chefs Club"
  },
  {
    id: "authentic-thai-green-curry",
    title: "Authentic Thai Green Curry",
    prepTime: "30 mins",
    servings: 4,
    diet: "Dairy-Free",
    cuisine: "Thai",
    mealType: "Main Course",
    rating: 4.8,
    image: PicRecipe3,
    description: "A fragrant coconut green curry infused with Thai basil, kaffir lime leaves, bamboo shoots, and tender chicken or tofu.",
    ingredients: [
      { ingredient: "Thai Green Curry Paste", count: "3", unit: "tbsp" },
      { ingredient: "Coconut Milk", count: "1", unit: "can (400ml)" },
      { ingredient: "Chicken Thighs or Tofu", count: "400", unit: "g" },
      { ingredient: "Thai Eggplant & Bamboo Shoots", count: "1", unit: "cup" },
      { ingredient: "Fresh Thai Basil Leaves", count: "1/2", unit: "cup" }
    ],
    directions: [
      "Fry green curry paste in 2 tbsp coconut cream until fragrant and oil separates.",
      "Add chicken thighs and stir-fry for 3 minutes.",
      "Pour in remaining coconut milk, chicken broth, kaffir lime leaves, and eggplant.",
      "Simmer for 15 minutes, finish with fish sauce, palm sugar, and fresh Thai basil."
    ],
    nutrition: { calories: "410 kcal", protein: "28g", carbs: "12g", fat: "29g" },
    club: "Asian Street Food Explorers"
  },
  {
    id: "berry-acai-smoothie-bowl",
    title: "Berry Acai Smoothie Bowl",
    prepTime: "10 mins",
    servings: 1,
    diet: "Vegan / Raw",
    cuisine: "Brazilian / Modern",
    mealType: "Breakfast",
    rating: 4.9,
    image: PicRecipe4,
    description: "Thick antioxidant-rich acai berry blend topped with organic granola, fresh blueberries, banana slices, chia seeds, and coconut flakes.",
    ingredients: [
      { ingredient: "Frozen Acai Packet", count: "1", unit: "packet (100g)" },
      { ingredient: "Frozen Strawberries & Blueberries", count: "1", unit: "cup" },
      { ingredient: "Almond Milk", count: "1/4", unit: "cup" },
      { ingredient: "Organic Crunchy Granola", count: "1/3", unit: "cup" },
      { ingredient: "Chia Seeds & Coconut Flakes", count: "1", unit: "tbsp" }
    ],
    directions: [
      "Blend acai packet, frozen berries, banana, and almond milk on high until smooth and thick.",
      "Pour thick smoothie into a bowl.",
      "Arrange sliced banana, fresh berries, granola, chia seeds, and coconut flakes in neat rows on top."
    ],
    nutrition: { calories: "310 kcal", protein: "6g", carbs: "54g", fat: "9g" },
    club: "Smoothie & Morning Club"
  },
  {
    id: "creamy-mushroom-risotto",
    title: "Creamy Mushroom Risotto",
    prepTime: "40 mins",
    servings: 4,
    diet: "Vegetarian",
    cuisine: "Italian",
    mealType: "Main Course",
    rating: 4.8,
    image: PicRecipe1,
    description: "Silky Arborio rice slow-cooked with white wine, wild cremini and shiitake mushrooms, thyme, and aged Parmigiano-Reggiano.",
    ingredients: [
      { ingredient: "Arborio Rice", count: "1.5", unit: "cups" },
      { ingredient: "Mixed Mushrooms (sliced)", count: "300", unit: "g" },
      { ingredient: "Warm Vegetable Broth", count: "4", unit: "cups" },
      { ingredient: "Dry White Wine", count: "1/2", unit: "cup" },
      { ingredient: "Parmigiano-Reggiano", count: "1/2", unit: "cup" }
    ],
    directions: [
      "Saute mushrooms in butter with garlic and thyme until browned; set half aside for garnish.",
      "In a deep pan, translucent diced shallots and Arborio rice.",
      "Deglaze with white wine and stir until absorbed.",
      "Ladle warm broth 1/2 cup at a time, stirring constantly until rice is creamy and al dente.",
      "Fold in parmesan cheese, butter, and cooked mushrooms."
    ],
    nutrition: { calories: "390 kcal", protein: "10g", carbs: "58g", fat: "12g" },
    club: "Comfort Food Classics"
  },
  {
    id: "sourdough-artisan-loaf",
    title: "Sourdough Artisan Loaf",
    prepTime: "45 mins",
    servings: 10,
    diet: "Artisanal",
    cuisine: "French / European",
    mealType: "Bread",
    rating: 5.0,
    image: PicRecipe2,
    description: "Classic wild yeast sourdough bread with a blistered golden crust, airy open crumb, and deep authentic tangy flavor.",
    ingredients: [
      { ingredient: "Bread Flour", count: "500", unit: "g" },
      { ingredient: "Water", count: "350", unit: "g" },
      { ingredient: "Active Sourdough Starter", count: "100", unit: "g" },
      { ingredient: "Fine Sea Salt", count: "10", unit: "g" }
    ],
    directions: [
      "Mix flour, water, and active sourdough starter; perform stretch and folds every 30 mins for 2 hours.",
      "Bulk ferment dough until rose 50% with visible bubbles.",
      "Shape into a round boule and cold proof in a banneton basket overnight (12-16 hours).",
      "Score top with a sharp razor blade and bake in a preheated Dutch oven at 450°F (230°C) with lid on for 20 mins, then 20 mins lid off."
    ],
    nutrition: { calories: "180 kcal", protein: "6g", carbs: "36g", fat: "1g" },
    club: "Artisanal Baking & Desserts"
  }
];
